import { render, staticRenderFns } from "./AddFlawModal.vue?vue&type=template&id=ff262da8"
import script from "./AddFlawModal.vue?vue&type=script&lang=js"
export * from "./AddFlawModal.vue?vue&type=script&lang=js"
import style0 from "./AddFlawModal.vue?vue&type=style&index=0&id=ff262da8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports